import request from '@/utils/request';

export enum MemorySourceType {
  Model = 'MODEL',
  User = 'USER',
}

export enum MemoryTagType {
  Character = 'CHARACTER',
  Fact = 'FACT',
  Relation = 'RELATION',
}

export interface MemoryFragmentItem {
  bailianMemoryId?: string;
  botId?: string;
  content?: string;
  createTime?: string;
  id?: number;
  sessionId?: string;
  sourceType?: MemorySourceType;
  status?: number;
  tagType?: MemoryTagType;
  updateTime?: string;
  userId?: string;
  version?: number;
  [property: string]: any;
}

export interface MemoryFragmentListParams {
  botId?: string;
  isLimit?: boolean;
  lastId?: number;
  page?: number;
  sessionId?: string;
  size?: number;
  sourceType?: MemorySourceType;
  tagType?: MemoryTagType;
  userId?: string;
  [property: string]: any;
}

export interface MemoryFragmentListResult {
  currentPage?: number;
  list?: MemoryFragmentItem[];
  totalCount?: number;
  totalPage?: number;
  [property: string]: any;
}

export interface MemoryFragmentUpdateParams {
  content?: string;
  id?: number;
  tagType?: MemoryTagType;
  [property: string]: any;
}

export interface MemoryFragmentAddParams {
  botId?: string;
  content?: string;
  sessionId?: string;
  tagType?: MemoryTagType;
  [property: string]: any;
}

export interface ExtractNoteMemoryRequest {
  botId?: string;
  id?: number | string;
  operatorUserId?: string;
  [property: string]: any;
}

export interface ExtractAllNoteMemoryRequest {
  botId?: string;
  operatorUserId?: string;
  [property: string]: any;
}

export const feimaChatMemoryFragmentList = (
  data: MemoryFragmentListParams,
  options?: any
): Promise<MemoryFragmentListResult> =>
  request<any>('/ai/memory/fragment/list', 'POST', data, options);

export const feimaChatMemoryFragmentUpdate = (
  data: MemoryFragmentUpdateParams,
  options?: any
): Promise<MemoryFragmentItem> =>
  request<any>('/ai/memory/fragment/update', 'POST', data, options);

export const feimaChatMemoryFragmentAdd = (
  data: MemoryFragmentAddParams,
  options?: any
): Promise<MemoryFragmentItem> =>
  request<any>('/ai/memory/fragment/add', 'POST', data, options);

export const feimaChatMemoryFragmentNoteExtract = (
  data: ExtractNoteMemoryRequest,
  options?: any
): Promise<boolean> =>
  request<any>('/ai/memory/fragment/note/extract', 'POST', data, options);

export const feimaChatMemoryFragmentNoteExtractAll = (
  data: ExtractAllNoteMemoryRequest,
  options?: any
): Promise<boolean> =>
  request<any>('/ai/memory/fragment/note/extractAll', 'POST', data, options);

export const feimaChatMemoryFragmentDelete = (
  data: { id?: number },
  options?: any
): Promise<boolean> =>
  request<any>('/ai/memory/fragment/delete', 'POST', data, options);

export interface MemoryFragmentBatchReadParams {
  ids?: number[];
}

export const feimaChatMemoryFragmentBatchRead = (
  data: MemoryFragmentBatchReadParams,
  options?: any
): Promise<boolean> =>
  request<any>('/ai/memory/fragment/batchRead', 'POST', data, options);
